import React from 'react';
import AICharacter from '../AICharacter';
import styled from '@xstyled/styled-components';
import { MOBILE_BREAKPOINT } from '../../common/Constants';

const ResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  padding-top: 5px;
  padding-bottom: 10px;
  box-sizing: border-box;
  margin-bottom: 53px;
  width: clamp(96%, 1vw, 100%);

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin-bottom: 87px;
  }
`;

const ResponsesContainer = ({
    responseHistory,
    setResponseHistory
}) => {
    // Use a ref to handle the response container's reference
    
    const toggleResponseOpen = (id) => {
        setResponseHistory(prevHistory =>
            prevHistory.map(response =>
                response.id === id ? { ...response, isResponseOpen: !response.isResponseOpen } : response
            )
        );
    };

    const handleResponseFetched = (id, newResponse) => {
        setResponseHistory(prevHistory =>
            prevHistory.map(response =>
                response.id === id ? { ...response, response: newResponse } : response
            )
        );
    };

    const handleCheckboxChange = (id) => {
        setResponseHistory(prevHistory =>
          prevHistory.map(response =>
            response.id === id ? { ...response, isChecked: !response.isChecked } : response
          )
        );
      };
    
    const handleDeleteResponse = (id) => {
        setResponseHistory(prevHistory =>
            prevHistory.filter(response => response.id !== id)
        );
    };

    return (
        <ResponseContainer data-testid='scrollable-response-container'>
            {responseHistory.map(response => (
                <AICharacter
                    data-testid='character-response'
                    key={response.id}
                    responseID={response.id}
                    characterConfig={response.characterConfig}
                    userInput={response.userInput}
                    previousResponses={response.previousResponses}
                    isFakeResponse={response.isFakeResponse}
                    isSummarizer={response.isSummarizer}
                    isResponseOpen={response.isResponseOpen}
                    toggleResponse={() => toggleResponseOpen(response.id)}
                    onResponseFetched={(newResponse) => handleResponseFetched(response.id, newResponse)}
                    onCheckboxChange={handleCheckboxChange}
                    isChecked={response.isChecked}
                    onDeleteResponse={handleDeleteResponse}
                />
            ))}
        </ResponseContainer>
    );
};

export default ResponsesContainer;
